import { render, staticRenderFns } from "./classification-items.vue?vue&type=template&id=8c4ae722&scoped=true&"
import script from "./classification-items.vue?vue&type=script&lang=js&"
export * from "./classification-items.vue?vue&type=script&lang=js&"
import style0 from "./classification-items.vue?vue&type=style&index=0&id=8c4ae722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ae722",
  null
  
)

export default component.exports